import './titlecontainer.css'

import parse from 'html-react-parser';
import Icons from './icons/Icons';
import { IconColors } from '../../services/SystemNames';
import { CopyToClipboard } from './CopyToClipboard';
import { isArrayEmpty, isNullOrEmpty } from '../helpers/ObjectHelpers';

export default function TitleContainer(
    {
        title = "",
        subTitle = "",
        canCopySubTitle = false,
        size = "medium",
        icon = "",
        iconColor = IconColors.Primary,
        iconDimensions = 40,
        actions = [],
        error = false
    }
) {
    return (
        <>
            <div className={`${error ? 'title-container-error' : ''} title-container title-container-${size}`}>
                <div className="title-container-icon">
                    {
                        !isNullOrEmpty(icon) &&
                        <Icons iconName={icon} color={iconColor} dimensions={iconDimensions} />
                    }
                </div>
                <div>
                    <div className="title-container-text font-size-xxxl">
                        {parse(title)}
                    </div>
                </div>
                <div className={`${error ? 'title-container-error-actions' : ''} ${isArrayEmpty(actions) ? '' : 'title-container-actions'}`}>
                    {
                        actions.map((action, index) =>
                            <div key={index} onClick={action.onClick}>
                                <Icons iconName={action.icon} color={getActionIconColor(action)} dimensions={26} />
                            </div>
                        )
                    }
                </div>
            </div>
            {
                (!isNullOrEmpty(subTitle)) &&
                <div className="title-container-sub-title">
                    {
                        canCopySubTitle ?
                            <CopyToClipboard text={subTitle} />
                            :
                            parse(subTitle)
                    }
                </div>
            }
        </>
    );

    function getActionIconColor(action) {
        if (!Object.hasOwn(action, "iconColor")) return IconColors.Primary;
        return action.iconColor;
    }
}
